import type {
  EntityAction,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestProductOrPlanBySlug = ({
  qs,
  slug,
  resourceType,
  callbacks,
}: {
  qs: any,
  slug: string,
  resourceType?: string,
  callbacks?: any,
}): EntityAction => ({
  type: actionTypes.REQUEST_PRODUCT_OR_PLAN_BY_SLUG,
  qs,
  slug,
  resourceType,
  callbacks,
});

export const requestProductPlansByNamespace = ({
  namespace,
  callbacks,
}): EntityAction => ({
  type: actionTypes.REQUEST_PRODUCT_PLANS_BY_NAMESPACE,
  namespace,
  callbacks,
});

export const requestBuyProduct = ({
  payload,
  callbacks,
}): EntityAction => ({
  type: actionTypes.REQUEST_BUY_PRODUCT,
  payload,
  callbacks,
});

export const requestFinishBuy = ({
  reinitializeResources,
  paymentIntentId,
  callbacks,
}: {
  reinitializeResources?: boolean,
  paymentIntentId: number,
  callbacks: any,
}): EntityAction => ({
  type: actionTypes.REQUEST_FINISH_BUY,
  reinitializeResources,
  paymentIntentId,
  callbacks,
});
